export class DocumentClass {
  static UNDEFINED = -1;
  static MEDICAL = 0;
  static PSICOPEDAGOGIC = 1;
  static SCHOOL = 2;
}
